// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"1a58651b","608":"03f7eb38","843":"66974ae0"}[chunkId] + ".chunk.css";
};